export default __webpack_public_path__ + "static/media/sprint_retro.02bba857.png";